import { render, staticRenderFns } from "./CollapseConfig.vue?vue&type=template&id=7b02d809&scoped=true&"
import script from "./CollapseConfig.vue?vue&type=script&lang=ts&"
export * from "./CollapseConfig.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseConfig.vue?vue&type=style&index=0&id=7b02d809&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b02d809",
  null
  
)

export default component.exports